import ListTodo from "./Todo";
import type { Action, DayType } from "@/types/types";
import type { Dispatch } from "react";
import NewTodo from "./NewTodo";
import { AnimatePresence } from "motion/react";

const weekdayFormat = new Intl.DateTimeFormat("en-US", { weekday: "long" });
const dateFormat = new Intl.DateTimeFormat("en-US", {
  day: "numeric",
  month: "long",
});

export default function Day({
  day,
  dispatch,
  index,
}: {
  day: DayType;
  dispatch: Dispatch<Action>;
  index: number;
}) {
  const heading =
    index === 0
      ? "Today"
      : index === 1
        ? "Tomorrow"
        : weekdayFormat.format(day.date);

  return (
    <section className="day" data-date={day.date.toISOString()}>
      <div className="heading">
        <h2>{heading}</h2>
        <p>{dateFormat.format(day.date)}</p>
      </div>
      <ul>
        <AnimatePresence>
          {day.todos.map((todo) => (
            <ListTodo key={todo.id} dispatch={dispatch} todo={todo}></ListTodo>
          ))}
        </AnimatePresence>

        <NewTodo key={day.date.getDate()} dispatchTodos={dispatch} day={day} />
      </ul>
    </section>
  );
}
